import { Icon, Input } from '@design';
import React, { ChangeEvent, KeyboardEvent } from 'react';

import styles from './FilterSearch.module.scss';

interface FilterSearchProps {
  searchPlaceholder?: string;
  value: string;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
  onClear: () => void;
}

export const FilterSearch = ({
  searchPlaceholder,
  value,
  onChange,
  onClear,
}: FilterSearchProps) => {
  const onKeyDown = (e: KeyboardEvent) => {
    e.stopPropagation();
  };

  return (
    <Input
      className={styles.search}
      size="medium"
      data-testid="filter-search"
      placeholder={searchPlaceholder}
      onKeyDown={onKeyDown}
      onChange={onChange}
      leftIcon={<Icon iconName="Search" size={20} />}
      rightIcon={
        !!value.length && (
          <Icon iconName="CloseCircle" size={16} onClick={onClear} />
        )
      }
      value={value}
    />
  );
};
